module.exports = __webpack_public_path__ + "img/P150T_weapon_130.0f90edcb.png";